module.exports = __webpack_public_path__ + "static/media/alarm_image.f6abc5ac.png";